import { createFileRoute } from "@tanstack/react-router";
import ActionsAudit from "@/components/views/ActionsAudit";

export const Route = createFileRoute("/audit")({
  component: ActionsAudit,
});
